import { useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { useQuery } from '@apollo/client';
import { useContextMenu } from 'react-contexify';

import LoadingSpinner from '../LoadingSpinner';
import ErrorText from '../ErrorText';
import { AUDIENCES_QUERY } from '../../queries';

type SavedAudiencesListProps = {
  className?: string;
  onSavedAudienceClick: (name: string) => void;
  currentAudienceName: string;
};

export default function SavedAudiencesList({
  className,
  onSavedAudienceClick,
  currentAudienceName,
}: SavedAudiencesListProps) {
  const [open, setOpen] = useState(false);

  const { loading, error, data } = useQuery(AUDIENCES_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const { show } = useContextMenu({
    id: 'delete-only',
  });

  return (
    <div className={`w-full ${className ? className : ''}`}>
      <div
        onClick={() => setOpen((prevState) => !prevState)}
        className="flex flex-row items-center hover:bg-gray-200 cursor-pointer p-1 -ml-2 rounded-lg"
      >
        <div>{open ? <FaAngleUp /> : <FaAngleDown />}</div>
        <div className="pl-1">Saved Audiences</div>
      </div>
      <div
        className={`py-2 pl-5 flex flex-row h-full w-full overflow-auto ${
          open ? 'visible' : 'hidden'
        }`}
      >
        {loading && (
          <LoadingSpinner message={`Getting your saved audiences...`} />
        )}
        {!loading && error && <ErrorText message={error.message} />}
        {!loading && !error && data && (
          <ul>
            {data.audiences.map(({ name }, idx) => (
              <li className={`py-0.5`} key={idx}>
                <button
                  type="button"
                  className={`text-left ${
                    currentAudienceName === name
                      ? 'opacity-50 cursor-default'
                      : ''
                  }`}
                  onClick={() =>
                    currentAudienceName !== name && onSavedAudienceClick(name)
                  }
                  onContextMenu={(e) =>
                    show(e, {
                      props: { name, resourceType: 'savedAudiences' },
                    })
                  }
                >
                  {name}
                </button>
              </li>
            ))}
            {data.audiences?.length === 0 && <p>{`No saved audiences`}</p>}
          </ul>
        )}
      </div>
    </div>
  );
}
